import "./assets/css/styles.css";
import React, { useEffect, useRef, useState } from "react";
import AnimatePage from "./subpages/animatepage.js";
import { useForm } from "@formspree/react";
import { Link } from "react-scroll";

const hobbies = [
    { icon: "fa-solid fa-moon", text: "Aerospace engineering" },
    { icon: "fa-solid fa-person-snowboarding", text: "Snowboarding" },
    { icon: "fa-solid fa-chess", text: "Practicing chess tactics" },
    { icon: "fa-solid fa-futbol", text: "Playing football" },
    { icon: "fa-solid fa-podcast", text: "Listening to science podcasts" },
    { icon: "fa-solid fa-cube", text: "Solving Rubik's cubes" },
];

function ContactForm() {
    const [state, handleSubmit] = useForm("moqzblnv");

    useEffect(() => {
        if (!state.succeeded) {
            return;
        }

        for (const form of document.getElementsByTagName("form")) {
            form.reset();
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [state.succeeded]);

    return (<section className="contact animation">
        <div className="titleabout" id='contact'>Get in touch</div>
        <div className="contact-form">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-lg-6" style={{ paddingRight: "50px" }}>
                        <div className="form-group">
                            <input type="text" name="name" placeholder="Full Name" className="form-control" />
                        </div>
                    </div>
                    <div className="col-lg-6" style={{ paddingRight: "50px", width: "400px" }}>
                        <div className="form-group">
                            <input type="text" name="email" placeholder="Email Adress" className="form-control" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="form-group">
                            <input type="text" name="subject" placeholder="Subject" className="form-control" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="form-group">
                            <textarea name="message" placeholder="Your Message" className="form-control"></textarea>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <button type="submit" disabled={state.submitting} className="btn btn-2"><i className="fa-solid fa-envelope"></i> Send Message</button>
                    </div>
                </div>
            </form>
        </div>
    </section>
    );
}

const Home = () => {
    const observer = useRef(null);
    const [currentHobby, setCurrentHobby] = useState(0);

    useEffect(() => {
        let delay = 800;

        observer.current = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const isTimingElement = entry.target.classList.contains("timing");

                        if (isTimingElement) {
                            setTimeout(() => {
                                entry.target.classList.add("animation-show");
                            }, delay);

                            delay += 60;
                        } else {
                            entry.target.classList.add("animation-show");
                        }

                        observer.current?.unobserve(entry.target);
                    }
                });
            },
            {
                rootMargin: "-100px 0px 0px 0px",
            }
        );

        const animationElements = document.querySelectorAll(".animation");
        animationElements.forEach((el) => observer.current.observe(el));

        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentHobby((prev) => (prev + 1) % hobbies.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <AnimatePage>
                <section className="home">
                    <div className="content">
                        <section className="startname" id="home">
                            <div className="welcome animation timing">Hello, my name is</div>

                            <span className="namesubname animation timing">
                                Patryk<jk style={{ marginLeft: "-15px" }}> Kuna</jk>
                            </span>

                            <div className="hello animation timing">
                                I am a <lp className="bolden">Computer Physics student</lp>, interested in applied physics, scientific computing, numerical methods and aerospace engineering. I use C++ for numerical algorithms, data analysis and technical projects connecting physics, mathematics and software.
                            </div>

                            <div className="resume-cont animation timing">
                                <Link activeClass="active" smooth={true} spy={true} to="contact" offset={-100}>
                                    <div className="resume-button">Get in touch</div>
                                </Link>

                                <a href="/Patryk_Kuna_resume.pdf" target="_blank" rel="noreferrer">
                                    <div className="resume">Resume</div>
                                </a>
                            </div>

                            <div className="social-icons animation timing">
                                <a
                                    href="https://github.com/Patis0nek"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="clickable"
                                >
                                    <i className="fab fa-github"></i>
                                </a>
                                <a
                                    href="https://www.linkedin.com/in/patrykkuna"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="clickable"
                                >
                                    <i className="fab fa-linkedin-in"></i>
                                </a>
                                <a
                                    href="https://x.com/Patis0nek"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="clickable"
                                >
                                    <i className="fab fa-x-twitter"></i>
                                </a>
                                <a
                                    href="https://codepen.io/Patis0nek"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="clickable"
                                >
                                    <i className="fab fa-codepen"></i>
                                </a>
                                <span className="line"></span>
                            </div>

                            <div className="social-icons r-icons animation timing">
                                <div className="email">
                                    <a href="mailto:kuna.patryk@gmail.com">kuna.patryk@gmail.com</a>
                                </div>
                                <span className="line"></span>
                            </div>
                        </section>

                        <div className="titleabout animation">About Me</div>

                        <section className="aboutme" id="about" style={{ paddingBottom: "200px" }}>
                            <div className="textabout animation">
                                I’m Patryk, a third-year Computer Physics student at{" "}
                                <a
                                    href="https://www.agh.edu.pl/en"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="clickable"
                                >
                                    AGH University of Science and Technology
                                </a>{" "}
                                in Kraków. with a strong interest in software development and scientific computing.
                                <br /><br />
                                My journey started with graphic design in 2019, which naturally evolved into programming a year later. Since then, I have been building web applications while continuously developing my analytical and technical skills.
                                <br /><br />
                                Through my studies, I work with advanced mathematics and physics, including multivariable calculus, vector calculus, quantum mechanics, and statistical physics. I apply numerical methods and programming to solve computational problems and better understand physical systems.
                                <br /><br />
                                Alongside my academic work, I develop modern, user-focused web applications using React, combining clean design with performance and functionality.
                                <br /><br />
                                Technologies I work with include C++, Python, HTML, CSS, JavaScript and React.js
                                <br /><br />
                            </div>

                            <ul style={{ fontWeight: "200" }} className="langicons animation">
                                <li><i className="fab fa-cuttlefish"></i> C++</li>
                                <li><i className="fab fa-python"></i> Python</li>
                                <li><i className="fab fa-html5"></i> HTML5</li>
                                <li><i className="fab fa-css3-alt"></i> CSS</li>
                                <li className="react-logo">
                                    <i className="fa-brands fa-react" style={{ fontWeight: "600" }}></i> React.js
                                </li>
                                <li><i className="fab fa-js"></i> JavaScript</li>
                            </ul>

                            <div className="textabout ndtext animation">
                                <br />
                                Here are a few things I love doing
                                <br />
                            </div>

                            <div
                                className="animation"
                                style={{
                                    maxWidth: "1080px",
                                    marginTop: "0px",
                                    minHeight: "70px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "left",
                                    textAlign: "center",
                                }}
                            >
                                <div className="item">
                                    <i className={hobbies[currentHobby].icon}></i>{" "}
                                    {hobbies[currentHobby].text}
                                </div>
                            </div>
                        </section>

                        <div className="titleabout animation">Projects</div>

                        <section className="projects" id="projects">
                            <div className="project animation">
                                <div className="description">
                                    <div className="names">Magnetic Field Mapper</div>
                                    <span>
                                        An interactive scientific visualization project for mapping magnetic
                                        fields in the browser. The application combines C++ physics code,
                                        OpenGL rendering and Emscripten compilation to WebAssembly/WebGL,
                                        allowing a C++ simulation to run directly inside a web interface.
                                    </span>
                                    <div className="linksite">
                                        C++ | OpenGL | Emscripten{" "}
                                        <a href="https://github.com/nborkala/MagneticFieldSimulation" target="_blank" rel="noreferrer">
                                            <i className="fab fa-github"></i>
                                        </a>
                                        <a href="https://magnetic-field-simulator.netlify.app" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                        </a>
                                    </div>
                                </div>
                                <img src="/magnetic-field-mapper.png" alt="Magnetic Field Mapper project" />
                            </div>

                            <div className="project animation">
                                <div className="description">
                                    <div className="names">Mars Mission Simulator</div>
                                    <span>
                                        A 3D physics-based C++ simulation of a Starship-like mission to Mars.
                                        The project models orbital motion, gravitational interactions,
                                        atmospheric entry, aerodynamic braking and a simplified landing burn.
                                        Python scripts are used to generate trajectory plots and animations.
                                    </span>
                                    <div className="linksite">
                                        C++ | Python | Orbital Mechanics{" "}
                                        <a href="https://github.com/Patis0nek/mars-entry-landing" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                        </a>
                                    </div>
                                </div>
                                <img src="/mars.png" alt="Mars" />
                            </div>

                            <div className="project animation">
                                <div className="description">
                                    <div className="names">Numerical Methods</div>
                                    <span>
                                        A collection of C++ laboratory projects focused on numerical methods
                                        used in computational physics. The repository includes implementations
                                        of algorithms for solving nonlinear equations, interpolation,
                                        approximation, matrix methods, optimization and eigenvalue problems.
                                    </span>
                                    <div className="linksite">
                                        C++ | OpenBLAS/LAPACK{" "}
                                        <a href="https://github.com/Patis0nek/numerical-methods" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                        </a>
                                    </div>
                                </div>
                                <img src="/numerical-methods.png" alt="Numerical Methods in Physics project" />
                            </div>

                            <div className="project animation">
                                <div className="description">
                                    <div className="names">Great Aletsch Glacier</div>
                                    <span>
                                        A scientific computing project analyzing surface area and approximate
                                        volume changes of the lower tongue of the Great Aletsch Glacier in
                                        Switzerland. The analysis uses Sentinel-2 satellite imagery from
                                        2015, 2020 and 2025, together with DEM-derived elevation-change data.
                                    </span>
                                    <div className="linksite">
                                        Python | Sentinel-2 | Remote Sensing{" "}
                                        <a href="https://github.com/Patis0nek/aletsch-glacier-change" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                        </a>
                                    </div>
                                </div>
                                <img src="/aletsch-glacier.png" alt="Great Aletsch Glacier remote sensing project" />
                            </div>

                            <div className="project animation">
                                <div className="description">
                                    <div className="names">AGH Space Systems</div>
                                    <span>
                                        A website project for AGH Space Systems, a student engineering
                                        organization working on rockets, rovers, stratospheric experiments,
                                        and space-related research projects. My work focused on improving
                                        the website structure, content presentation, visual consistency and
                                        user experience.
                                    </span>
                                    <div className="linksite">
                                        WordPress | Front-End | UX/UI{" "}
                                        <a href="https://www.spacesystems.agh.edu.pl" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                        </a>
                                    </div>
                                </div>
                                <img src="/agh-space-systems.png" alt="AGH Space Systems website project" />
                            </div>

                            <div className="project animation">
                                <div className="description">
                                    <div className="names">Sports Event Website</div>
                                    <span>
                                        It is an informational website for a real school event. I designed
                                        the graphics and provided several data on sports disciplines,
                                        along with minimalistic icons. Moreover, the website's simple and
                                        uncluttered design allows for a clean and user-friendly experience
                                        for visitors.
                                    </span>
                                    <div className="linksite">
                                        React | Bootstrap | OwlCarousel{" "}
                                        <a href="https://github.com/Patis0nek/Dzien-Sportu" target="_blank" rel="noreferrer">
                                            <i className="fab fa-github"></i>
                                        </a>
                                        <a href="https://dziensportu.netlify.app/" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                        </a>
                                    </div>
                                </div>
                                <img src="/dziensportu.png" alt="dziensportu" />
                            </div>

                        </section>

                        <section className="projects-more">
                            <div className="proj animation">
                                <div className="description">
                                    <div className="title">
                                        <i className="fa-solid fa-rocket"></i> Moon Mission Simulator
                                    </div>
                                    A small C++ numerical physics project simulating an Earth-Moon
                                    free-return trajectory. The program models Earth and Moon gravity,
                                    a moving Moon, RK4 integration and a simple search for initial
                                    mission parameters.
                                    <div className="linksite">
                                        C++ | Orbital Mechanics | RK4{" "}
                                        <a href="https://github.com/Patis0nek/moon-mission-simulator" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square linko"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="proj animation">
                                <div className="description">
                                    <div className="title">
                                        <i className="fa-solid fa-shoe-prints"></i> Sneaker Release App
                                    </div>
                                    This is a web application that provides information on upcoming
                                    fashion trends. Users can track the latest and past releases,
                                    receive updates on current drafts and sales.
                                    <div className="linksite">
                                        React.js | Google Firebase | jQuery{" "}
                                        <a href="https://drops0n-react.netlify.app" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square linko"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="proj animation">
                                <div className="description">
                                    <div className="title">
                                        <i className="fa-solid fa-dice"></i> Random Picker
                                    </div>
                                    I created this project to help my teacher, who was struggling
                                    with the random selection of students for short tests using a
                                    random number generator.
                                    <div className="linksite">
                                        React.js | Google Firebase{" "}
                                        <a href="https://github.com/Patis0nek/Fizos" target="_blank" rel="noreferrer">
                                            <i className="fab fa-github linko linko2"></i>
                                        </a>
                                        <a href="https://fizyka-losowanie.netlify.app" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square linko"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="proj animation">
                                <div className="description">
                                    <div className="title">
                                        <i className="fa-solid fa-message"></i> Global Chat
                                    </div>
                                    Worm Chat is a messenger-like chat application that allows you to
                                    communicate on global chat channel with other registered users.
                                    <div className="linksite">
                                        Google Firebase | Google Auth{" "}
                                        <a href="https://github.com/Patis0nek/Worm-Chat" target="_blank" rel="noreferrer">
                                            <i className="fab fa-github linko linko2"></i>
                                        </a>
                                        <a href="https://worm-chat.netlify.app/" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square linko"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="proj animation">
                                <div className="description">
                                    <div className="title">
                                        <i className="fa-solid fa-moon"></i> Solar System Animation
                                    </div>
                                    The Solar System animation project is a straightforward simulation
                                    depicting the Sun and its planets orbiting it within their designated
                                    paths, accurately representing their relative velocities.
                                    <div className="linksite">
                                        CSS
                                        <a href="https://codepen.io/Patis0nek/full/yLREpao" target="_blank" rel="noreferrer">
                                            <i className="fa-solid fa-arrow-up-right-from-square linko"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </section>

                        <ContactForm />

                        <section className="credits">
                            Developed by <span style={{ color: "#ECB365" }}>Patryk Kuna</span>
                            <span style={{ display: "block", marginTop: "4px" }}>All rights reserved</span>
                        </section>
                    </div>
                </section>
            </AnimatePage>
        </div>
    );
};

export default Home;